import { TableCell, TableRow } from '@mui/material';
import { Spin } from 'antd';
import { Link } from 'react-router-dom';

import { DynamicTable } from 'components/dynamicTable';
import useTranslation from 'customHooks/translate';
import { tableHeaderStyle } from 'consts';

import Tabs from '../components/Tabs';

const IncomesTable = ({
  incomesTableContainerRef,
  incomesTableData,
  incomesLoadingRef,
  isLoadingMoreIncomes,
  hasMoreIncomes,
  activeTab,
  setActiveTab,
  setOpen,
}) => {
  const translation = useTranslation();

  return (
    <div
      className="relative max-h-[600px] overflow-y-auto"
      ref={incomesTableContainerRef}
    >
      <div className="flex flex-wrap items-center justify-between gap-[10px] px-[16px] py-[12px] md:px-[32px]">
        <div className="flex w-full items-center justify-between gap-[24px] md:w-auto md:justify-start">
          <p className="text-[18px] font-semibold text-[#1D1D1D] md:text-[20px]">
            {translation.reports.Incomes}
          </p>
          <button
            onClick={() => setOpen(true)}
            className="flex items-center rounded-[8px] bg-[#F6F6F6] px-[20px] py-[8px] text-[14px] font-medium text-black"
          >
            <img
              className="mr-[6px] h-5 w-5"
              src="./assets/filter.svg"
              alt=""
            />
            {translation.filter}
          </button>
        </div>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      <DynamicTable
        hasData={incomesTableData?.length > 0}
        headerCellStyle={tableHeaderStyle}
        cells={[
          `${translation.reports.Date}`,
          `${translation.reports.InvoiceNo}`,
          `${translation.reports.JobNumber}`,
          `${translation.reports.CustomerName}`,
          `${translation.reports.Amount}`,
          `${translation.reports.Status}`,
          `${translation.reports.Manager}`,
        ]}
      >
        {incomesTableData.map((item, i) => (
          <TableRow
            key={i}
            sx={{
              '&:last-child td, &:last-child th': { border: 0 },
              '&:nth-of-type(odd)': {
                backgroundColor: ' rgba(70, 106, 251, 0.03);',
              },
            }}
          >
            <TableCell align="center">
              {item.invoiceDate.slice(0, 10)}
            </TableCell>
            <TableCell align="center">
              <Link
                style={{
                  paddingLeft: '20px',
                  cursor: 'pointer',
                  background: '#FFFFFF',
                  color: '#466AFB',
                  padding: '5px 10px',
                  border: '1px solid rgba(70, 106, 251, 0.25)',
                  borderRadius: '5px',
                }}
                to={`/invoices/${item.invoiceId}/detail`}
              >
                {item.invoiceNumber}
              </Link>
            </TableCell>
            <TableCell align="center">{item.jobnumber}</TableCell>
            <TableCell align="center" sx={{ width: 200 }}>
              {item.name}
            </TableCell>
            <TableCell align="center">
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(item.amount || 0)}{' '}
              {item.currency}
            </TableCell>
            <TableCell align="center">{item.status}</TableCell>
            <TableCell align="center">{item.managerName}</TableCell>
          </TableRow>
        ))}
      </DynamicTable>
      <div
        className="flex min-h-[50px] flex-col items-center justify-center py-[16px] text-center"
        ref={incomesLoadingRef}
      >
        {isLoadingMoreIncomes && <Spin size="small" />}
        {!hasMoreIncomes && incomesTableData.length > 0 && (
          <div style={{ color: '#999', marginTop: '8px' }}>
            {translation.messages.allData}
          </div>
        )}
      </div>
    </div>
  );
};

export default IncomesTable;
